import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
export function useMenuLinks(_ref) {
  var links = _ref.links,
      onClick = _ref.onClick,
      closeOther = _ref.closeOther;

  var _useState = useState(links),
      _useState2 = _slicedToArray(_useState, 2),
      localLinks = _useState2[0],
      setLocalLinks = _useState2[1];

  var toggleMenuItem = function toggleMenuItem(link) {
    setLocalLinks(function (prev) {
      return getListWithChangedOpenStatus(prev, link.key);
    });

    if (onClick) {
      onClick(link);
    }
  };

  var getListWithChangedOpenStatus = function getListWithChangedOpenStatus(list, id) {
    return list.map(function (link) {
      var newLink = link;

      if (newLink.key === id) {
        return _objectSpread(_objectSpread({}, newLink), {}, {
          opened: !newLink.opened
        });
      }

      if (closeOther) {
        newLink.opened = false;
      }

      if (newLink.menu) {
        return _objectSpread(_objectSpread({}, newLink), {}, {
          menu: _objectSpread(_objectSpread({}, newLink.menu), {}, {
            links: getListWithChangedOpenStatus(newLink.menu.links, id)
          })
        });
      }

      return newLink;
    });
  };
  /**
   * @param {Link} link
   */


  var getPrepareLink = function getPrepareLink(link) {
    var currentLink = link;

    if (currentLink.menu) {
      currentLink = _objectSpread(_objectSpread({}, currentLink), {}, {
        menu: _objectSpread(_objectSpread({}, currentLink.menu), {}, {
          links: currentLink.menu.links.map(getPrepareLink)
        })
      });
    }

    return _objectSpread(_objectSpread({}, currentLink), {}, {
      onClick: function onClick() {
        return toggleMenuItem(link);
      }
    });
  };

  useEffect(function () {
    var updatedLinks = localLinks.map(function (link) {
      return getPrepareLink(link);
    });
    setLocalLinks(updatedLinks); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    links: localLinks
  };
}